<div class="superadmin-layout">
  <!-- Top Navigation -->
  <header class="top-navbar">
    <div class="navbar-left">
      <div class="brand">
        <i class="fas fa-shield-alt"></i>
        <span>Super Admin</span>
      </div>
    </div>

    <nav class="navbar-nav">
      <a routerLink="/superadmin/activity" routerLinkActive="active" class="nav-link">
        <i class="fas fa-clipboard-list"></i>
        <span>Activity Logs</span>
      </a>
      <a routerLink="/superadmin/analytics" routerLinkActive="active" class="nav-link">
        <i class="fas fa-chart-bar"></i>
        <span>Analytics</span>
      </a>
      <a routerLink="/superadmin/settings" routerLinkActive="active" class="nav-link">
        <i class="fas fa-cog"></i>
        <span>Settings</span>
      </a>
    </nav>

    <div class="navbar-right">
      <div class="user-info">
        <i class="fas fa-user-circle"></i>
        <span>{{ currentUser?.name || 'Admin User' }}</span>
      </div>
    </div>
  </header>

  <!-- Main Content Area -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
